<template>
  <UiSectionWrapper
    title="Bangun Tim yang Aman dan Efisien"
    sub-title="Manajemen Staff"
    description="Nikmati sistem kerja yang lebih terkontrol, aman dan transparan"
    hero-image="/images/manajemen-staff-banner-4.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
    button-label="Aktifkan Sekarang"
    :button-link="
      $utm.utmUrl('/login', {
        redirectTo: '/staff'
      })
    "
  />
</template>
